import React, { useState } from 'react';
import { Modal, ModalHeader, ModalFooter, Button } from 'reactstrap';
import { deleteFeed } from 'utils/api';
import { toast } from 'react-toastify';
import SpinnerButton from 'components/SpinnerButton';

const FeedDeleteModal = ({ isOpen, toggle, source, refreshList }) => {
    const [deleting, setDeleting] = useState(false);

    const onConfirm = async () => {
        try {
            setDeleting(true);
            await deleteFeed(source.id);
            await refreshList(true);
            toast.success('Fetch successfully deleted');
            toggle();
        } catch (err) {
            setDeleting(false);
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            }
            console.log(err);
            throw err;
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                <strong>Are you sure you want to delete {source.attachedName}?</strong>
            </ModalHeader>
            <ModalFooter className="select-fetches-modal-footer" style={{ borderTop: 'none' }}>
                <Button style={{ color: 'white' }} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    minWidth="83.63px"
                    title="Delete"
                    submitting={deleting}
                    onClick={onConfirm}
                />
            </ModalFooter>
        </Modal>
    );
};

export default FeedDeleteModal;